import { CalendarSetStatus, Colors, ICalendarSet } from "@miplatform/types";
import { canActivateCalendarSet } from "./CalendarSetDetails/CalendarSetDetails.util";
import { ICalendarSetData } from "./ConfigCalendarSetList.types";

export const getCalendarSetStatusActions = (
  { status, ...data }: Partial<ICalendarSet> | Partial<ICalendarSetData>,
  onUpdate: (data: Partial<ICalendarSet>) => void
) => {
  const actions = [];

  if (status !== CalendarSetStatus.Active) {
    actions.push({
      label: "Activate",
      disabled: !canActivateCalendarSet(data),
      action: () => {
        const updatedData = { ...data, status: CalendarSetStatus.Active };
        onUpdate(updatedData as Partial<ICalendarSet>);
      },
    });
  }

  if (status !== CalendarSetStatus.Draft) {
    actions.push({
      label: "Draft",
      action: () => {
        const updatedData = { ...data, status: CalendarSetStatus.Draft };
        onUpdate(updatedData as Partial<ICalendarSet>);
      },
    });
  }

  if (status !== CalendarSetStatus.Inactive) {
    actions.push({
      label: "Deactivate",
      action: () => {
        const updatedData = { ...data, status: CalendarSetStatus.Inactive };
        onUpdate(updatedData as Partial<ICalendarSet>);
      },
    });
  }

  return actions;
};

export const getCalendarSetStatusColor = (status: CalendarSetStatus) => {
  switch (status) {
    case CalendarSetStatus.Active:
      return Colors.Success;
    case CalendarSetStatus.Draft:
      return Colors.Orange;
    case CalendarSetStatus.Inactive:
      return Colors.Grey;
    default:
      return Colors.Grey;
  }
};
